import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { img_ios_1, img_scr_ios_LightKeyboard, img_scr_status_Bar_Ios } from '../../../../utils/ImagesManagementUtils';
import { getRef, getRegularFont, xlateText } from '../../../../utils/Utils';
import OnBoardingTopTitlesIOS from '../../AuxiliaryComponent/MixComponent/OnBoardingTopTitlesIOS';
import SentenceWIthEmuji from '../../AuxiliaryComponent/MixComponent/SentenceWIthEmuji';

//= ========================================================================
const SelectKeyboardIosFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;
  const myStyles = {
    phoneImage: {
      width: 240,
      height: 520,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },
    firstLineContainer: {
      width: 122,
      height: 14,
      marginTop: 82,
      marginLeft: 36,
      marginBottom: 10,
    },
    firstLineText: {
      textAlign: 'center',
      fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#000',
    },
    secondLineContainer: {
      width: 122,
      height: 14,
      marginLeft: 36,
    },
    secondLineText: {
      width: 122,
      textAlign: 'center',
      fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      color: '#fff',
    },
    keyboardKeyContainer: {
      width: 122,
      height: 14,
      marginLeft: 105,
      marginTop: 10,
      justifyContent: 'center',
    },
    keyboardKeyText: {
      fontSize: 7.1,
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: -0.14,
      width: 122,
      textAlign: 'center',
      fontFamily: `${getRegularFont(globJSON, simPlatform, true)}`,
      color: '#030303',
    },
    topBarStatusStyle: {
      width: '100%',
      height: 20,
      marginBottom: -20,
    },
    smallKeyboardImageStyle: {
      width: 165,
      height: 119,
    },
    keyboardImageStyle: {
      marginTop: 80,
      width: '100%',
      height: 185,
    },
  };

  return (
    <View style={myStyles.phoneImage} ref={getRef(slideshowRefs)}>
      <Image
        fadeDuration={0}
        style={myStyles.topBarStatusStyle}
        source={img_scr_status_Bar_Ios}
      />
      <OnBoardingTopTitlesIOS
        globJSON={globJSON}
        simPlatform={simPlatform}
        subTitle={instructions.o_i_step_2_of_2}
        Title={xlateText(instructions.o_i_switch_to_bank_keyboard, globJSON)}
      />
      <SentenceWIthEmuji
        globJSON={globJSON}
        simPlatform={simPlatform}
      />
      <View style={{ alignSelf: 'center', position: 'absolute', marginTop: 180 }}>
        <Image
          fadeDuration={0}
          style={myStyles.smallKeyboardImageStyle}
          source={img_ios_1}
        />
      </View>

      <View style={myStyles.firstLineContainer}>
        <Text style={myStyles.firstLineText}>
          {xlateText(instructions.other_keyboards, globJSON)}
        </Text>
      </View>

      <View style={myStyles.secondLineContainer}>
        <Text style={myStyles.secondLineText}>
          {xlateText(instructions.bank_keyboard, globJSON)}
        </Text>
      </View>
      <View style={myStyles.keyboardKeyContainer}>
        <Text style={myStyles.keyboardKeyText}>
          {xlateText(instructions.keyboard_button, globJSON)}
        </Text>
      </View>
      <Image
        fadeDuration={0}
        style={myStyles.keyboardImageStyle}
        source={img_scr_ios_LightKeyboard}
      />
    </View>

  );
};

export default SelectKeyboardIosFP;
